import React, { Component } from 'react';

class CarouselRightArrow extends Component {
  getButtonStyles(disabled) {
    return {
      border: 0,
      background: 'transparent',
      padding: 10,
      paddingRight: 20,
      outline: 0,
      opacity: disabled ? 0.3 : 1,
      cursor: 'pointer'
    };
  }

  getImageStyles() {
    return {
      height: '28px'
    };
  }

  render() {
    const self = this;
    return (
      <button
        style={this.getButtonStyles(self.props.currentSlide + self.props.slidesToScroll >=
         self.props.slideCount && !self.props.wrapAround)}
        onClick={self.props.nextSlide}
      >
        <input
          type="image"
          src="static/right_arrow.png"
          alt="NEXT"
          style={this.getImageStyles()}
        />
      </button>
    );
  }
}

export default CarouselRightArrow;



// WEBPACK FOOTER //
// ./src/components/CarouselRightArrow/CarouselRightArrow.js